import { render } from "./ProductButtons.vue?vue&type=template&id=6679bf06&scoped=true"
import script from "./ProductButtons.vue?vue&type=script&lang=js"
export * from "./ProductButtons.vue?vue&type=script&lang=js"

import "./ProductButtons.vue?vue&type=style&index=0&id=6679bf06&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6679bf06"]])

export default __exports__